import { gql } from "@apollo/client";
import { BREAKDOWN, FEES_FOR_PAX, SSRS } from "./fragments";

export const GET_SSR_AVAILABILITY = gql`
  query ssrAvailability {
    ssrAvailabilityv2{
      journeySsrs {
        journeyKey
        ssrs {
          available
          feeCode
          limitPerPassenger
          name
          passengersAvailability {
            key
            value {
              passengerKey
              price
              ssrKey
            }
          }
          seatDependent
          ssrCode
          ssrType
        }
      }
      legSsrs {
        legKey
        ssrs {
          available
          feeCode
          limitPerPassenger
          name
          passengersAvailability {
            key
            value {
              passengerKey
              price
              ssrKey
            }
          }
          seatDependent
          ssrCode
          ssrType
        }
      }
      segmentSsrs {
        segmentKey
        ssrs {
          available
          feeCode
          limitPerPassenger
          name
          passengersAvailability {
            key
            value {
              passengerKey
              price
              ssrKey
            }
          }
          seatDependent
          ssrCode
          ssrType
        }
      }
    }
    bookingBundleAvailability {
      bundleCode
      hasPrice
      pricesByJourney {
        value {
          journeyKey
          prices {
            feePrice
            taxTotal
            totalPrice
            includedSsrs {
              bundleSsrPrice
              legSsrs {
                legKey
                available
                feeCode
                limitPerPassenger
                name
                passengersAvailability {
                  value {
                    passengerKey
                    price
                    ssrKey
                  }
                }
                ssrCode
                ssrType
              }
              journeySsr {
                available
                journeyKey
                feeCode
                limitPerPassenger
                name
                passengersAvailability {
                  value {
                    passengerKey
                    price
                    ssrKey
                  }
                }
                ssrCode
                ssrType
              }
              segmentSsrs {
                available
                feeCode
                limitPerPassenger
                name
                passengersAvailability {
                  value {
                    passengerKey
                    price
                    ssrKey
                  }
                }
                ssrCode
                ssrType
              }
            }
            upgradableSsrs {
              isFeeWaived
              amounts {
                amount
                currencyCode
                ssrNumber
              }
              currencyCode
              discountPercent
              isFeeWaived
              legSsrs {
                available
                feeCode
                limitPerPassenger
                name
                passengersAvailability {
                  value {
                    passengerKey
                    price
                    ssrKey
                  }
                }
                ssrCode
                ssrType
              }
              journeySsr {
                available
                feeCode
                limitPerPassenger
                name
                passengersAvailability {
                  value {
                    passengerKey
                    price
                    ssrKey
                  }
                }
                ssrCode
                ssrType
              }
              segmentSsrs {
                available
                feeCode
                limitPerPassenger
                name
                passengersAvailability {
                  value {
                    passengerKey
                    price
                    ssrKey
                  }
                }
                ssrCode
                ssrType
              }
            }
            additionalSsrs {
              legSsrs {
                available
                feeCode
                limitPerPassenger
                name
                passengersAvailability {
                  value {
                    passengerKey
                    price
                    ssrKey
                  }
                }
                ssrCode
                ssrType
              }
              journeySsr {
                available
                feeCode
                limitPerPassenger
                name
                passengersAvailability {
                  value {
                    passengerKey
                    price
                    ssrKey
                  }
                }
                ssrCode
                ssrType
              }
              segmentSsrs {
                available
                feeCode
                limitPerPassenger
                name
                passengersAvailability {
                  value {
                    passengerKey
                    price
                    ssrKey
                  }
                }
                ssrCode
                ssrType
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_LOWFARE_ESTIMATE = gql`
  query Estimate($request: Input_LowFareEstimateRequest) {
    availabilityLowFareEstimate(request: $request) {
      lowFares {
        date
        available
        noFlights
        price
        referenceFareKeys
        soldOut
        taxesAndFees
      }
    }
  }
`;
export const GET_AVAILABILITY_SEARCH = gql`
  query availabilityv4($request: Input_AvailabilityRequestv2) {
    availabilityv4(request: $request) {
      results {
        trips {
          date
          journeysAvailableByMarket {
            key
            value {
              journeyKey
              designator {
                arrival
                departure
                destination
                origin
              }
              stops
              flightType
              fares {
                fareAvailabilityKey
                details {
                  reference
                  status
                  availableCount
                  bundleReferences
                  ssrReferences
                  reference
                  serviceBundleSetCode
                }
              }
              segments {
                segmentKey
                identifier {
                  carrierCode
                  identifier
                  opSuffix
                }
                designator {
                  arrival
                  departure
                  destination
                  origin
                }
                legs {
                  designator {
                    arrival
                    departure
                    destination
                    origin
                  }
                  flightReference
                  legInfo {
                    adjustedCapacity
                    arrivalTerminal
                    arrivalTime
                    arrivalTimeUtc
                    capacity
                    departureTerminal
                    departureTime
                    departureTimeUtc
                    eTicket
                    equipmentType
                  }
                  ssrs {
                    available
                    sold
                    ssrNestCode
                    unitSold
                  }
                }
              }
            }
          }
        }
      }
      includeTaxesAndFees
      faresAvailable {
        key
        value {
          fareAvailabilityKey
          totals {
            fareTotal
            discountedTotal
          }
          fares {
            classOfService
            classType
            productClass
            fareApplicationType
            passengerFares {
              discountedFare
              passengerType
              publishedFare
              revenueFare
              serviceCharges {
                amount
                code
                currencyCode
                detail
                foreignAmount
                foreignCurrencyCode
                type
              }
            }
            ruleNumber
          }
        }
      }
    }
  }
`;

export const GET_CURRENT_BOOKING_STATE = gql`
  ${FEES_FOR_PAX}
  query booking {
    booking {
      info {
        status
      }
      typeOfSale {
        promotionCode
      }
      queues {
        code
        name
        type
        flightReference
      }
      bookingKey
      recordLocator
      breakdown {
        balanceDue
        authorizedBalanceDue
        totalAmount
        totalToCollect
        passengers {
          key
        }
        passengers {
          key
          value {
            services {
              charges {
                amount
                code
                detail
              }
              taxes
              adjustments
            }
            nameChanges {
              adjustments
              charges {
                amount
                code
                detail
              }
              total
            }
            convenience {
              adjustments
              charges {
                amount
                code
                detail
              }
              taxes
              total
            }
            infant {
              adjustments
              charges {
                amount
                code
                detail
              }
              taxes
              total
            }
          }
        }
      }
      passengerSegments: journeys {
        journeyKey
        segments {
          segmentKey
          passengerSegment {
            passengerKey: key
            value {
              liftStatus
              hasInfant
              seats {
                arrivalStation
                compartmentDesignator
                departureStation
                passengerKey
                seatInformation {
                  propertyList {
                    key
                    value
                  }
                }
                isPending
                penalty
                unitDesignator
                unitKey
              }
              ssrs {
                count
                feeCode
                passengerKey
                ssrCode
                ssrKey
                ssrNumber
                isConfirmed
                inBundle
                market {
                  departureDate
                  destination
                  origin
                }
              }
            }
          }
          designator {
            arrival
            departure
            destination
            origin
          }
        }
      }
      contacts {
        key
        value {
          emailAddress
          name {
            first
            last
          }
          phoneNumbers {
            number
            type
          }
        }
      }
      journeys {
        flightType
        designator {
          origin
          destination
          arrival
          departure
        }
        journeyKey
        segments {
          segmentKey
          identifier {
            carrierCode
            identifier
            opSuffix
          }
          status
          designator {
            origin
            destination
            arrival
            departure
          }
          segmentKey
          identifier {
            identifier
            carrierCode
            opSuffix
          }
          passengerSegment {
            value {
              liftStatus
              passengerKey

              seats {
                arrivalStation
                compartmentDesignator
                departureStation
                passengerKey
                seatInformation {
                  propertyList {
                    key
                    value
                  }
                }
                unitDesignator
                unitKey
              }
              ssrs {
                count
                feeCode
                passengerKey
                isConfirmed
                ssrCode
                ssrKey
                ssrNumber
                isConfirmed
                inBundle
                market {
                  departureDate
                  destination
                  origin
                }
              }
            }
          }
          cabinOfService
          fares {
            fareKey
            productClass
            classOfService
            passengerFares {
              passengerType
              serviceCharges {
                amount
                code
                currencyCode
                detail
                type
              }
            }
          }
          flightReference
          international
          isStandby
          legs {
            designator {
              origin
              destination
              arrival
              departure
            }
            legKey
            legInfo {
              arrivalTimeUtc
              departureTimeUtc
              arrivalTerminal
              departureTerminal
            }
            operationsInfo {
              departureTimes {
                estimated
                scheduled
              }
              arrivalGate {
                actualGate
                estimatedGate
              }
              departureGate {
                actualGate
                estimatedGate
              }
            }
            seatmapReference
          }
        }
        stops
      }
      passengers {
        key
        value {
          passengerTypeCode
          passengerKey
          name {
            first
            last
            middle
          }
          info {
            dateOfBirth
            familyNumber
            gender
            nationality
            residentCountry
          }
          passengerTypeCode
          customerNumber
          infant {
            fees {
              code
              detail
              serviceCharges {
                amount
                currencyCode
                type
              }
            }
            dateOfBirth
            gender
            name {
              first
              last
            }
            nationality
            residentCountry
            type
            travelDocuments {
              passengerTravelDocumentKey
              birthCountry
              documentTypeCode
              expirationDate
              issuedByCode
              nationality
              number
              name
              gender
              dateOfBirth
            }
          }
          travelDocuments {
            passengerTravelDocumentKey
            birthCountry
            documentTypeCode
            expirationDate
            issuedByCode
            nationality
            number
            name
            gender
            dateOfBirth
          }
        }
      }
      passengerFaresReference: journeys {
        journeyKey
        segments {
          fares {
            passengerFares {
              passengerType
              serviceCharges {
                amount
                code
                currencyCode
                detail
                type
              }
            }
          }
          segmentKey
          flightReference
          legs {
            legKey
            flightReference
          }
        }
      }
      fees: passengers {
        ...fees
      }
      payments {
        paymentKey
        amounts {
          amount
          collected
        }
        details {
          accountNumber
          installments
          parentPaymentId
          accountName
          expirationDate
          fields {
            key
            value
          }
        }
        voucher {
          overrideAmount
        }
        status
        authorizationStatus
        code
        createdDate
      }
    }
  }
`;

export const GET_CURRENT_BOOKING_STATE_CHECKIN = gql`
  ${FEES_FOR_PAX}
  ${BREAKDOWN}
  ${SSRS}
  query booking {
    booking {
      info {
        status
      }
      bookingKey
      selfServiceMoveAvailable
      recordLocator
      currencyCode
      typeOfSale {
        promotionCode
      }
      queues {
        code
        name
        type
        flightReference
      }
      sales {
        created {
          organizationCode
        }
      }
      contacts {
        value {
          customerNumber
          emailAddress
          name {
            ...name
          }
          phoneNumbers {
            number
            type
          }
          contactTypeCode
          companyName
        }
      }
      journeys {
        flightType
        designator {
          origin
          destination
          arrival
          departure
        }
        journeyKey
        segments {
          segmentKey
          identifier {
            carrierCode
            identifier
            opSuffix
          }
          status
          designator {
            origin
            destination
            arrival
            departure
          }
          segmentKey
          identifier {
            identifier
            carrierCode
            opSuffix
          }
          passengerSegment {
            value {
              liftStatus
              passengerKey

              seats {
                arrivalStation
                compartmentDesignator
                departureStation
                passengerKey
                isPending
                penalty
                seatInformation {
                  propertyList {
                    key
                    value
                  }
                }
                unitDesignator
                unitKey
              }
              ssrs {
                count
                feeCode
                passengerKey
                ssrCode
                ssrKey
                ssrNumber
                isConfirmed
                inBundle
                isConfirmed
                market {
                  departureDate
                  destination
                  origin
                }
              }
            }
          }
          cabinOfService
          fares {
            fareKey
            productClass
            classOfService
            passengerFares {
              passengerType
              serviceCharges {
                amount
                code
                currencyCode
                detail
                type
              }
            }
          }
          flightReference
          international
          isStandby
          legs {
            designator {
              origin
              destination
              arrival
              departure
            }
            legKey
            legInfo {
              arrivalTimeUtc
              departureTimeUtc
              arrivalTerminal
              departureTerminal
            }
            operationsInfo {
              departureTimes {
                estimated
                scheduled
              }
              arrivalGate {
                actualGate
                estimatedGate
              }
              departureGate {
                actualGate
                estimatedGate
              }
            }
            seatmapReference
          }
        }
        stops
      }
      passengers {
        key

        value {
          name {
            ...name
          }

          passengerTypeCode
          passengerAlternateKey
          info {
            dateOfBirth
            familyNumber
            gender
            nationality
            residentCountry
          }
          addresses {
            city
            companyName
            countryCode
            emailAddress
            lineOne
            lineTwo
            lineThree
            passengerAddressKey
            phone
            postalCode
            provinceState
            stationCode
            status
          }
          customerNumber
          discountCode
          infant {
            dateOfBirth
            gender
            name {
              ...name
            }
            nationality
            residentCountry
            travelDocuments {
              passengerTravelDocumentKey
              birthCountry
              documentTypeCode
              expirationDate
              issuedByCode
              issuedDate
              name {
                ...name
              }
              nationality
              number
            }
          }
          travelDocuments {
            passengerTravelDocumentKey
            birthCountry
            documentTypeCode
            expirationDate
            issuedByCode
            issuedDate
            name {
              ...name
            }
            nationality
            number
          }
          program {
            code
            levelCode
            number
          }
        }
      }
      breakdown {
        ...breakdown
      }
      seats: journeys {
        ...seats
      }
      passengerSegments: journeys {
        journeyKey
        segments {
          segmentKey
          passengerSegment {
            passengerKey: key

            value {
              name {
                ...name
              }
              liftStatus
              hasInfant
            }
          }
        }
      }
      fees: passengers {
        ...fees
      }
      passengerFaresReference: journeys {
        journeyKey
        segments {
          fares {
            passengerFares {
              passengerType
              serviceCharges {
                amount
                code
                currencyCode
                detail
                type
              }
            }
          }
          segmentKey
          flightReference
          legs {
            legKey
            flightReference
          }
        }
      }
      payments {
        paymentKey
        amounts {
          amount
          collected
        }
        details {
          accountNumber
          installments
          parentPaymentId
          accountName
          expirationDate
          fields {
            key
            value
          }
        }
        voucher {
          overrideAmount
        }
        status
        authorizationStatus
        code
        createdDate
      }
    }
  }

  # Name
  fragment name on Name {
    first
    last
    middle
    title
    suffix
  }

  fragment charge on ChargeBreakdown {
    charges {
      amount
      collectType
      code
      currencyCode
      detail
      type
    }
    taxes
    total
  }

  fragment seats on Journey {
    segments {
      segmentKey
      passengerSegment {
        passengerKey: key
        value {
          seats {
            arrivalStation
            compartmentDesignator
            departureStation
            passengerKey
            penalty
            seatInformation {
              propertyList {
                key
                value
              }
            }
            unitDesignator
            unitKey
          }
        }
      }
    }
  }
`;

export const GET_SEATMAP = gql`
  query seatmap {
    booking: booking {
      journeys {
        journeyKey
        segments {
          segmentKey
          identifier {
            identifier
            carrierCode
          }
          legs {
            legKey
            legInfo {
              equipmentType
            }
            seatmapReference
          }
        }
      }
    }
    seatMaps: seatMapsv2 {
      ssrLookup {
        ssrKey: key
        value {
          allowed
          ssrCode
          feeCode
          ssrType
          seatRestriction
        }
      }
      seatMap {
        seatmapReference
        name
        arrivalStation
        departureStation
        decks {
          deckNumber: key
          value {
            number
            compartments {
              designator: key
              value {
                length
                width
                orientation
                sequence
                designator
                availableUnits
                units {
                  allowedSsrs
                  angle
                  assignable
                  availability
                  compartmentDesignator
                  designator
                  group
                  height
                  priority
                  set
                  setVacancy
                  text
                  type
                  unitKey
                  width
                  x
                  y
                  zone
                  properties {
                    code
                    value
                  }
                }
              }
            }
          }
        }
      }
      passengerFees: fees {
        passengerKey: key
        value {
          groups {
            groupNumber: key
            value {
              group
              fees {
                code
                flightReference
                override
                passengerFeeKey
                type
                serviceCharges {
                  amount
                  code
                  currencyCode
                  detail
                  type
                }
              }
            }
          }
          passengerKey
        }
      }
    }
  }
`;

export const MANAGE_BOOKING_RETRIEVE = gql`
  ${FEES_FOR_PAX}
  ${SSRS}
  query ($request: Input_RetrieveBookingv2) {
    booking: bookingRetrievev2(request: $request) {
      selfServiceMoveAvailable
      recordLocator
      currencyCode
      queues {
        code
        name
        type
        flightReference
      }
      sales {
        created {
          organizationCode
        }
      }
      contacts {
        value {
          customerNumber
          emailAddress
          name {
            ...name
          }
          phoneNumbers {
            number
            type
          }
          contactTypeCode
        }
      }
      journeys {
        flightType
        designator {
          origin
          destination
          arrival
          departure
        }
        journeyKey
        segments {
          designator {
            origin
            destination
            arrival
            departure
          }
          segmentKey
          identifier {
            identifier
            carrierCode
            opSuffix
          }
          cabinOfService
          fares {
            fareKey
            productClass
            classOfService
          }
          flightReference
          international
          isStandby
          legs {
            designator {
              origin
              destination
              arrival
              departure
            }
            legKey
            legInfo {
              arrivalTimeUtc
              departureTimeUtc
              arrivalTerminal
              departureTerminal
            }
            operationsInfo {
              departureTimes {
                estimated
                scheduled
              }
            }
            seatmapReference
          }
        }
        stops
      }
      passengers {
        key
        value {
          name {
            ...name
          }
          passengerTypeCode
          info {
            dateOfBirth
            familyNumber
            gender
            nationality
            residentCountry
          }
          addresses {
            city
            companyName
            countryCode
            emailAddress
            lineOne
            lineTwo
            lineThree
            passengerAddressKey
            phone
            postalCode
            provinceState
            stationCode
            status
          }
          customerNumber
          discountCode
          infant {
            dateOfBirth
            gender
            name {
              ...name
            }
            nationality
            residentCountry
          }
          travelDocuments {
            passengerTravelDocumentKey
            birthCountry
            documentTypeCode
            expirationDate
            issuedByCode
            issuedDate
            name {
              ...name
            }
            nationality
            number
          }
          program {
            code
            levelCode
            number
          }
        }
      }
      breakdown {
        authorizedBalanceDue
        balanceDue
        journeyTotals {
          totalDiscount
          totalTax
          totalAmount
        }
        passengerTotals {
          infant {
            ...charge
          }
          seats {
            ...charge
          }
          specialServices {
            ...charge
          }
        }
        total: totalCharged
      }
      ssrs: journeys {
        ...ssrs
      }
      seats: journeys {
        ...seats
      }
      passengerSegments: journeys {
        journeyKey
        segments {
          segmentKey
          passengerSegment {
            passengerKey: key
            value {
              liftStatus
              hasInfant
            }
          }
        }
      }
      payments {
        paymentKey
        amounts {
          amount
          collected
        }
        details {
          accountNumber
          installments
          parentPaymentId
          accountName
          expirationDate
          fields {
            key
            value
          }
        }
        voucher {
          overrideAmount
        }
        status
        authorizationStatus
        code
        createdDate
      }
      fees: passengers {
        ...fees
      }
      passengerFaresReference: journeys {
        journeyKey
        segments {
          fares {
            passengerFares {
              passengerType
              serviceCharges {
                amount
                code
                currencyCode
                detail
                type
              }
            }
          }
          segmentKey
          flightReference
          legs {
            legKey
            flightReference
          }
        }
      }
    }
  }

  fragment name on Name {
    first
    last
    middle
    title
    suffix
  }

  fragment charge on ChargeBreakdown {
    charges {
      amount
      collectType
      code
      currencyCode
      detail
      type
    }
    taxes
    total
  }

  fragment seats on Journey {
    segments {
      segmentKey
      passengerSegment {
        passengerKey: key
        value {
          seats {
            arrivalStation
            compartmentDesignator
            departureStation
            passengerKey
            penalty
            seatInformation {
              propertyList {
                key
                value
              }
            }
            unitDesignator
            unitKey
          }
        }
      }
    }
  }
`;

export const CHECKIN_RETRIEVE = gql`
  query ($request: Input_RetrieveBookingv2) {
    booking: bookingRetrievev2(request: $request) {
      selfServiceMoveAvailable
      recordLocator
      currencyCode
    }
  }
`;

export const ORIGINANDDESTINATION = gql`
  query MasterData(
    $cultureCode: String!
    $stationsEtag: String
    $fareTypesEtag: String
    $passengerTypesEtag: String
    $suffixesTypesEtag: String
    $titlesTypesEtag: String
    $contactTypesEtag: String
  ) {
    stations: resourceStations(query: { activeOnly: true, cultureCode: $cultureCode, eTag: $stationsEtag }) {
      values {
        fullName
        locationDetails {
          cityCode
        }
        shortName
        fullName
        stationCode
      }
    }
    fareTypes: resourceFareTypes(query: { activeOnly: true, cultureCode: $cultureCode, eTag: $fareTypesEtag }) {
      eTag
      expiration
      values {
        allowed
        fareTypeCode
        inActive
        name
      }
    }
    passengerTypes: resourcePassengerTypes(
      query: { activeOnly: true, cultureCode: $cultureCode, eTag: $passengerTypesEtag }
    ) {
      values {
        allowed
        inActive
        maximumAge
        minimumAge
        name
        nonAdult
        passengerTypeCode
        typeIndicator
      }
    }
  }
`;

export const SELL_SSR = gql`
  mutation sell($request: Input_SsrByKeysRequestv2) {
    ssrsAddv2(request: $request) {
      count
      feeCode
      passengerKey
      ssrCode
      ssrKey
      ssrNumber
      market {
        departureDate
        destination
        origin
      }
    }
  }
`;

export const FETCH_FLIGHT_STATUS = gql`
  query ($request: Input_TripInformationSimpleQuery) {
    tripInformationSimple(request: $request) {
      journeys {
        journeyKey
        designator {
          destination
          origin
        }
        segments {
          identifier {
            identifier
            carrierCode
          }
          legs {
            designator {
              arrival
              departure
              destination
              origin
            }
            legKey
          }
        }
      }
    }
  }
`;
export const RETRIVE_BOOKING_JOURNEY = gql`
  query ($request: Input_RetrieveBookingv2) {
    booking: bookingRetrievev2(request: $request) {
      recordLocator
      journeys {
        flightType
        designator {
          origin
          destination
          arrival
          departure
        }
        journeyKey
        segments {
          designator {
            origin
            destination
            arrival
            departure
          }
          segmentKey
          identifier {
            identifier
            carrierCode
            opSuffix
          }

          isStandby
          legs {
            designator {
              origin
              destination
              arrival
              departure
            }
            legKey
            legInfo {
              arrivalTimeUtc
              departureTimeUtc
            }
          }
        }
        stops
      }
    }
  }
`;

export const RETRIVE_BOOKING_WITHOUT_PNR = gql`
  query ($request: Input_SearchBookingsByPhone) {
    booking: searchByPhonev2(request: $request) {
      origin
      recordLocator
      destination
      departureDate
      bookingStatus
      bookingKey
      expiredDate
      flightNumber
      name {
        first
        last
      }
      flightDate
    }
  }
`;
